{getIdsAsList, get_from_list} = require('../../../utils')

module.exports = {
  workflowStepIterations: (Api, $stateParams) ->
    Api.WorkflowStepIteration.query({workflow_step: $stateParams.workflowStepId}).$promise

  researchRequests: (Api, $stateParams) ->
    Api.ResearchRequest.query({workflow_step: $stateParams.workflowStepId})

  loadTemplates: ( $templateCache ) ->
    $templateCache.put('step-navigator', require('./step-navigator.html'))
    $templateCache.put('search-tabs', require('./search-tabs.html'))
}
